
<div class="card-message">
    <app-loading-mask *ngIf="loading"></app-loading-mask>
    <div class="card-message-title">
        <h6>{{ message }}</h6>
    </div>
    <h3>{{ value }}</h3>
</div>